import React, { useContext, useState, useEffect } from 'react'
import { LoadingContext, BufferService, M_InputTextField, M_Select, M_DrawerTableTextField, M_Button } from '../M_Components'
import { useTranslation } from 'react-i18next'
import {
  Box, Button, Grid, IconButton, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography, Tooltip, Divider
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import CloseIcon from '@mui/icons-material/Close'
import './logs.css'

export default function Logs() {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()
  const bufferServiceEntities = new BufferService('audit/entities')
  const bufferServiceRecent = new BufferService('audit/recent?page=1&pageSize=10')

  // --------- Recentes ----------
  const [recent, setRecent] = useState([])
  const [recentExpandedIdx, setRecentExpandedIdx] = useState(-1)
  // filtros timeline
  const [entityId, setEntityId] = useState('')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  // lista timeline
  const [rows, setRows] = useState([])
  const [expandedIdx, setExpandedIdx] = useState(-1)
  // pesquisa direta por logId
  const [logId, setLogId] = useState('')
  const [detail, setDetail] = useState(null)

  const listEntities = [
    { value: 'ServiceOrder', label: t("ServiceOrder") },
    { value: 'Agent', label: t("Agent") },
    { value: 'Carrier', label: t("Carrier") },
    { value: 'Driver', label: t("Driver") },
    { value: 'Trailer', label: t("Trailer") }// preciso adicionar a informação de novas entidades no BE ou BD
  ]

  const [entity, setEntity] = useState(listEntities[0].value)

  const resetAll = () => {
    setRows([])
    setExpandedIdx(-1)
    setDetail(null)
    setLogId('')
    setPage(1)
    setPageSize(20)
    setEntityId('')
  }

  const humanDate = (iso) => {
    if (!iso) return '-'
    const d = new Date(iso)
    return isNaN(d.getTime()) ? String(iso) : d.toLocaleString()
  }

  const ActionBadge = ({ value }) => {
    const v = (value || '').toUpperCase()
    const map = {
      CREATE: { bg: '#e8f5e9', color: '#2e7d32', label: 'Create' },
      UPDATE: { bg: '#fff8e1', color: '#f9a825', label: 'Update' },
      DELETE: { bg: '#ffebee', color: '#c62828', label: 'Delete' }
    }
    const m = map[v] || { bg: '#eceff1', color: '#546e7a', label: value || '-' }
    return (
      <span style={{
        background: m.bg, color: m.color, fontWeight: 700, padding: '2px 8px',
        borderRadius: 16, fontSize: 12
      }}>{t(m.label)}</span>
    )
  }

  useEffect(() => { loadRecent() }, []) // eslint-disable-line

  // --------- carregar Recentes ----------
  const loadRecent = () => {

    bufferServiceRecent.get().then(data => {
      if (data?.name === 'AxiosError') {
        ctx.toastMessages('error', t('ErrorGetData'), String(data?.message || 'Erro'))
        return
      }
      console.log("recent data", data)
      setRecent(Array.isArray(data) ? data : [])
    })
  }


  const exportToExcel = (data) => {
    if (!data || !data.length) {
      ctx.toastMessages('info', '', t('WithoutDataToExport'))
      return
    }
    const headers = Object.keys(data[0])

    const rows = data.map(obj =>
      headers.map(key => {
        const value = obj[key]
        if (typeof value === "object" && value !== null) {
          return JSON.stringify(value)
        }
        return value
      })
    )

    let csvContent =
      "\uFEFF" +
      headers.join(";") + "\n" +
      rows.map(row => row.join(";")).join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)

    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", "dados.csv")
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // timeline por entidade+id
  const loadTimeline = async () => {
    if (!entity || !entityId) {
      ctx.toastMessages('warning', '', t('FillEntityValue'))
      return
    }
    try {
      ctx.setIsLoad(true)
      setDetail(null)
      console.log('entity', entity, 'entityId', entityId)
      const path = `audit/${encodeURIComponent(entity)}/${encodeURIComponent(entityId)}?page=${page}&pageSize=${pageSize}`
      const api = new BufferService(path)
      const data = await api.get()
      if (data?.name === 'AxiosError') throw data
      const arr = Array.isArray(data) ? data : []
      setRows(arr)
      setExpandedIdx(-1)
      if (!arr.length) ctx.toastMessages('info', '', t('WithoutResultFilter'))
    } catch (e) {
      ctx.toastMessages('error', t('ErrorGetData'), String(e))
    } finally {
      ctx.setIsLoad(false)
    }
  }

  // detalhe por logId
  const loadByLogId = async () => {
    if (!logId?.trim()) return
    try {
      ctx.setIsLoad(true)
      setRows([]); setExpandedIdx(-1)
      const api = new BufferService(`audit/${encodeURIComponent(logId.trim())}`)
      const data = await api.get()
      if (!data || data?.name === 'AxiosError') {
        setDetail(null)
        ctx.toastMessages('error', t('ErrorGetData'), String(data?.message || 'Erro'))
        return
      }
      setDetail(data)
    } catch (e) {
      ctx.toastMessages('error', t('ErrorGetData'), String(e))
      setDetail(null)
    } finally {
      ctx.setIsLoad(false)
    }
  }

  return (
    <div className="divGlobalSettings">
      <div className="subTitleSettings">
        <div>
          <div style={{ color: ctx.secondaryColor }}>{t('Logs')}</div>
          <div className="labelSubtitleSettings">
            {t('InfoLogs')}
          </div>
        </div>
      </div>

      {/* Pesquisa direta por LogId */}
      <Box className="audit-filters correcao">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <M_InputTextField
              fullWidth
              size="small"
              label={t('LogId (GUID)')}
              value={logId}
              onChange={e => setLogId(e.target.value)}
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
              onKeyDown={(e) => e.key === 'Enter' && loadByLogId()}
            />
          </Grid>
          <Grid item xs={'auto'}>
            <Tooltip title={t('SearchByLogId')}>
              <span>
                <Button
                  variant="contained"
                  startIcon={<SearchIcon />}
                  onClick={loadByLogId}
                  disabled={ctx.isLoad}
                >
                  {t('Search')}
                </Button>
              </span>
            </Tooltip>
            <Tooltip title={t('Clear')}>
              <span>
                <IconButton
                  onClick={() => { setLogId(''); setDetail(null) }}
                  sx={{ ml: 1 }}
                  disabled={ctx.isLoad}
                >
                  <CloseIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>

      {/* Resultado do LogId (se existir) */}
      {detail && (
        <Paper className="audit-card" sx={{ mb: 2 }}>
          <div className="audit-detail-header">
            <Typography variant="subtitle1">{t('LogDetails')}</Typography>
            <IconButton size="small" onClick={() => setDetail(null)}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className="audit-detail-body">
            <div className="audit-detail-meta">
              <div><b>{t('Action')}:</b> <ActionBadge value={detail.Action} /></div>
              <div><b>{t('CreatedBy')}:</b> {detail.CreatedBy}</div>
              <div><b>{t('On')}:</b> {humanDate(detail.Date)}</div>
              <div><b>LogId:</b> {logId || detail.Id || '-'}</div>
            </div>
            <Table size="small" className="audit-table" sx={{ tableLayout: 'fixed' }}>
              <TableHead>
                <TableRow>
                  <TableCell className="th">{t('Field')}</TableCell>
                  <TableCell className="th">{t('OldValue')}</TableCell>
                  <TableCell className="th">{t('NewValue')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {detail.Obj?.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell className="nowrap">{row.Field}</TableCell>
                    <TableCell className="wrap">{row.OldValue ?? 'null'}</TableCell>
                    <TableCell className="wrap">{row.NewValue ?? 'null'}</TableCell>
                  </TableRow>
                ))}
                {(!detail.Obj || detail.Obj.length === 0) && (
                  <TableRow><TableCell colSpan={3}>{t('WithoutDifference')}</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </Paper>
      )}



      {/* Filtros de timeline por entidade+id */}
      <Box className="audit-filters">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={2}>
            <M_Select
              autocomplete
              fullWidth
              noNone
              label={t('Entities')}
              options={listEntities}
              value={listEntities.find(e => e.value === entity) || null}
              onChangeValue={(val) => setEntity(val?.value || '')}
              color={"var(--color-red)"}
              secondColor={"var(--color-red-dark)"}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            {/* colocar drawer */}
            <M_DrawerTableTextField
              tableLabel={t('IDEntity')}
              label={t('IDEntity')}
              required
              entity={entity}
              value={entityId ? { Id: entityId } : null}
              filterField={"Id"}
              labelFields={["Id"]}
              valueField={"Id"}
              onSubmitValue={obj => {
                console.log('obj', obj)
                if (obj) {
                  setEntityId(obj["Id"])
                  loadTimeline()
                } else {
                  setEntityId(null)
                }
              }}
              disabled={!entity}
            />

          </Grid>
          <Grid item xs={6} md={2}>
            <M_Select
              fullWidth
              noNone
              label={t('ItemsPerPage')}
              options={[10, 20, 50, 100].map(n => ({ value: n, label: String(n) }))}
              value={pageSize}
              onChange={e => { setPageSize(Number(e.target.value)); setPage(1) }}
              color={"var(--color-red)"}
              secondColor={"var(--color-red-dark)"}
            />

          </Grid>
          <Grid item xs={6} md={1}>
            <M_InputTextField
              type="number"
              fullWidth
              size="small"
              label={t('Page')}
              value={page}
              onChange={(e) => setPage(Math.max(1, Number(e.target.value || 1)))}
            // inputProps={{ min: 1 }}
            />
          </Grid>
          <Grid item xs={'auto'}>
            <Tooltip title={t('Search')}>
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={loadTimeline}
                disabled={ctx.isLoad}
              >
                {t('Search')}
              </Button>
            </Tooltip>
            <Tooltip title={t('Reload')}>
              <IconButton
                onClick={() => { setRows([]); loadTimeline() }}
                sx={{ ml: 1 }}
                disabled={ctx.isLoad}
              >
                <RestartAltIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t('Clear')}>
              <IconButton onClick={resetAll} sx={{ ml: 0.5 }} disabled={ctx.isLoad}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs="auto">
            <M_Button
              tooltip={t('ExportExcel')}
              onClick={() => exportToExcel(rows)}
              icon={
                <img
                  src="/icons/svgsDaNet/file-export.svg"
                  alt="Excel"
                  style={{
                    width: 25,
                    filter:
                      'invert(45%) sepia(45%) saturate(4638%) hue-rotate(72deg) brightness(96%) contrast(106%)',
                  }}
                />
              }
            />
          </Grid>
        </Grid>
      </Box>

      {/* Lista plana (timeline) */}
      <TableContainer component={Paper} className="audit-card">
        <Table size="small" stickyHeader sx={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 120 }}>{t('Action')}</TableCell>
              <TableCell>{t('CreatedBy')}</TableCell>
              <TableCell sx={{ width: 220 }}>{t('On')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r, idx) => {
              const isOpen = expandedIdx === idx
              return (
                <React.Fragment key={idx}>
                  <TableRow
                    hover
                    onClick={() => setExpandedIdx(isOpen ? -1 : idx)}
                    style={{ cursor: 'pointer', backgroundColor: isOpen ? '#fcfcfc' : undefined }}
                  >
                    <TableCell><ActionBadge value={r.Action} /></TableCell>
                    <TableCell>{r.CreatedBy}</TableCell>
                    <TableCell>{humanDate(r.Date)}</TableCell>
                  </TableRow>

                  {isOpen && (
                    <TableRow>
                      {/* colSpan=3 -> cobre todas as colunas da tabela superior */}
                      <TableCell colSpan={3} className="audit-expanded-cell">
                        <Table size="small" className="audit-table audit-table--inner" sx={{ tableLayout: 'fixed', width: '100%' }}>
                          <TableHead>
                            <TableRow>
                              <TableCell className="th">{t('Field')}</TableCell>
                              <TableCell className="th">{t('OldValue')}</TableCell>
                              <TableCell className="th">{t('NewValue')}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {r.Obj?.map((row, i2) => (
                              <TableRow key={i2}>
                                <TableCell className="nowrap">{row.Field}</TableCell>
                                <TableCell className="wrap">{row.OldValue ?? 'null'}</TableCell>
                                <TableCell className="wrap">{row.NewValue ?? 'null'}</TableCell>
                              </TableRow>
                            ))}
                            {(!r.Obj || r.Obj.length === 0) && (
                              <TableRow>
                                <TableCell colSpan={3}>{t('WithoutDifferences')}</TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              )
            })}
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  <Typography variant="body2" sx={{ opacity: .7 }}>{t('WithoutResults')}</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <br /><br />

      <Divider role="presentation" />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 14, marginBottom: 14 }}>
        <div>
          <div className='titleRecentLogs'>Logs Mais recentes</div>
          <div className='subtitleRecentLogs'>Aqui estão os logs mais recentes do sistema:</div>
        </div>
        <div>
          <M_Button
            tooltip={t('ExportExcel')}
            onClick={() => exportToExcel(recent)}
            icon={<img src="/icons/svgsDaNet/file-export.svg" alt="Excel" style={{ width: 25, filter: 'invert(45%) sepia(45%) saturate(4638%) hue-rotate(72deg) brightness(96%) contrast(106%)' }} />}
          />
        </div>
      </div>

      <Paper className="audit-card" style={{ marginBottom: 14 }}>
        <TableContainer>
          <Table size="small" stickyHeader sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: 160 }}>{t('Entidade')}</TableCell>
                <TableCell sx={{ width: 120 }}>{t('Ação')}</TableCell>
                <TableCell>{t('Created By')}</TableCell>
                <TableCell sx={{ width: 220 }}>{t('On')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {recent.map((r, idx) => {
                const isOpen = recentExpandedIdx === idx
                return (
                  <React.Fragment key={idx}>
                    <TableRow
                      hover
                      onClick={() => setRecentExpandedIdx(isOpen ? -1 : idx)}
                      style={{ cursor: 'pointer', backgroundColor: isOpen ? '#fcfcfc' : undefined }}
                    >
                      <TableCell>{r.Entity}</TableCell>
                      <TableCell><ActionBadge value={r.Action} /></TableCell>
                      <TableCell>{r.CreatedBy}</TableCell>
                      <TableCell>{humanDate(r.Date)}</TableCell>
                    </TableRow>

                    {isOpen && (
                      <TableRow>
                        {/* colSpan=4 -> cobre todas as colunas da tabela superior */}
                        <TableCell colSpan={4} className="audit-expanded-cell">
                          <Table size="small" className="audit-table audit-table--inner" sx={{ tableLayout: 'fixed', width: '100%' }}>
                            <TableHead>
                              <TableRow>
                                <TableCell className="th">{t('Field')}</TableCell>
                                <TableCell className="th">{t('Old Value')}</TableCell>
                                <TableCell className="th">{t('New Value')}</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {r.Obj?.map((row, i2) => (
                                <TableRow key={i2}>
                                  <TableCell className="nowrap">{row.Field}</TableCell>
                                  <TableCell className="wrap">{row.OldValue ?? 'null'}</TableCell>
                                  <TableCell className="wrap">{row.NewValue ?? 'null'}</TableCell>
                                </TableRow>
                              ))}
                              {(!r.Obj || r.Obj.length === 0) && (
                                <TableRow>
                                  <TableCell colSpan={3}>{t('Sem diferenças')}</TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                )
              })}
              {recent.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="body2" sx={{ opacity: .7 }}>{t('Sem resultados')}</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {/* --------- Fim Recentes --------- */}
    </div>
  )
}
